import { computed, onBeforeMount } from "vue"
import { mapBasketItemToGa4, trackBeginCheckout } from 'foundation/js/ecommerceTracking'
import BasketAside from "../BasketAside/BasketAside.vue"
import BasketCard from "../BasketCard/BasketCard.vue"
import FrivilligeCheckoutStepOne from "../FrivilligeCheckoutStepOne/FrivilligeCheckoutStepOne.vue"
import FrivilligeCheckoutStepTwo from "../FrivilligeCheckoutStepTwo/FrivilligeCheckoutStepTwo.vue"
import CheckoutStepThree from "../CheckoutStepThree/CheckoutStepThree.vue"
import { useStore } from "vuex"
import deepClone from "foundation/js/deepClone"

export default {
    name: "FrivilligeCheckoutContent",
    components: {
        BasketAside,
        BasketCard,
        FrivilligeCheckoutStepOne,
        FrivilligeCheckoutStepTwo,
        CheckoutStepThree
    },
    props: {
        userData: {
            type: Object,
            required: true
        }
    },
    setup(props) {
        const store = useStore()

        const getLabel = (labelKey) => store.getters['labels/getLabel']({ labelCollection: 'checkout', labelKey })
        
        const containsUdlaansvare = computed(() => store.state.basket.basketState.containsUdlaansvare)
        const checkoutInvoice = computed(() => store.state.checkout.purchaseData.invoice)
        const checkoutSteps = computed(() => store.state.checkout.checkoutSteps)
        const activeStep = computed(() => checkoutSteps.value.find((step) => step.active === true))
       
        onBeforeMount(() => {
            store.dispatch('basket/fetchBasket').then(() => {
                const isFirstStep = store.state.checkout.checkoutSteps
                    .find(s => s.active)?.stepNumber === 1
                if (isFirstStep) {
                    const items = store.state.basket.basket
                    if (items.length > 0) {
                        trackBeginCheckout(items.map((item, index) => mapBasketItemToGa4(item, index)))
                    }
                }
            })
            // set user data to invoice
            const invoiceCopy = deepClone(checkoutInvoice.value)
            invoiceCopy.userInformation.contactFirstName = props.userData.firstName ?? ''
            invoiceCopy.userInformation.contactLastName = props.userData.lastName ?? ''
            invoiceCopy.userInformation.email = props.userData.email ?? ''
            invoiceCopy.userInformation.mobilePhone = props.userData.phoneNumber ?? ''
            invoiceCopy.userInformation.customerType = 'frivillige'
            invoiceCopy.invoiceAddress.addressLine = props.userData.address ?? ''
            invoiceCopy.invoiceAddress.postalCode = props.userData.postalCode ?? ''
            invoiceCopy.invoiceAddress.city = props.userData.city ?? ''
            
            const newCheckoutSteps = deepClone(checkoutSteps.value)
            newCheckoutSteps[1].stepTitle = 'Levering'

            store.commit('checkout/set_checkout_steps', newCheckoutSteps)
            store.commit('checkout/set_purchase_data_invoice', invoiceCopy)
        })

        const determineCheckoutStepContent = function () {
            switch (activeStep.value.stepNumber) {
                case 1:
                    return 'FrivilligeCheckoutStepOne'
                case 2:
                    return 'FrivilligeCheckoutStepTwo'
                case 3:
                    return 'CheckoutStepThree'
                case 4:
                    // here user gets directed to receipt page
                    return
                default:
                    console.warn('No active checkout step defined')
                    break
            }
        }

        const checkoutDeliveryStepTitle = computed(() => {
            return containsUdlaansvare.value 
                ? getLabel('udlaanCheckoutStepTitle') 
                : activeStep.value.stepTitle
        })

        const handleStepClick = function (clickedStepNumber) {
            const validClickedStepNumber =
                clickedStepNumber < activeStep.value.stepNumber
                    ? clickedStepNumber
                    : activeStep.value.stepNumber
            store.commit('checkout/update_checkout_step', {
                nextStepNumber: validClickedStepNumber
            })
        }


        return {
            activeStep,
            checkoutSteps,
            checkoutDeliveryStepTitle,
            determineCheckoutStepContent,
            handleStepClick
        }
    }
}